import React from 'react';
import PropTypes from 'prop-types';
import { SunSphere, Rays, Icon } from './components';

var Sunny = function Sunny(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React.createElement(Icon, {
    size: size
  }, /*#__PURE__*/React.createElement(SunSphere, null, /*#__PURE__*/React.createElement(Rays, null)));
};

Sunny.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Icon Size */
  size: PropTypes.number
} : {};
Sunny.defaultProps = {
  size: 1
};
export default Sunny;